// React hook for matrix operations

import { useCallback, useMemo } from 'react';
import { Matrix, IVector2D } from '../types';
import { parseRawMatrix, locateResourceInMatrix, getMatrixCell } from '../core';

export interface IUseFloorMatrixReturn {
  matrix: Matrix | undefined;
  locateResourceId: (resourceId: number) => IVector2D | undefined;
  getCell: (coords: IVector2D) => unknown;
}

/**
 * React hook for working with floor plan matrices (legacy system)
 *
 * @param rawMatrix JSON string representation of the matrix
 * @returns Matrix operations
 */
export const useFloorMatrix = (rawMatrix?: string): IUseFloorMatrixReturn => {
  const matrix = useMemo(() => parseRawMatrix(rawMatrix), [rawMatrix]);

  const locateResourceId = useCallback(
    (resourceId: number): IVector2D | undefined => {
      return locateResourceInMatrix(resourceId, matrix);
    },
    [matrix]
  );

  const getCell = useCallback(
    (coords: IVector2D): unknown => {
      return getMatrixCell(coords, matrix);
    },
    [matrix]
  );

  return { matrix, locateResourceId, getCell };
};
